import _ from "lodash";
import i18n from "@/locale";
import html2canvas from "html2canvas";
import mixin from "@/mixins/global.js";

class Utils {
  constructor() { }
  // 遍历数组，获取新的id
  getNewId (array = [], key = "id") {
    let iId = -1;
    let bExist = false; // 是否已经存在

    for (let i = 1; ; i++) {
      bExist = false;
      iId = i;
      _.each(array, (value) => {
        if (value[key] === iId) {
          bExist = true;
          return false;
        }
      });
      // 如果没有存在则以此为新建页面名称
      if (!bExist) {
        break;
      }
    }
    return iId;
  }

  // 数组翻译
  getArray (arr) {
    const arrayResult = [];
    for (const itemO of arr) {
      const item = itemO === "loop" ? "programLoop" : itemO;
      // item === "loop" && (item = "programLoop");
      arrayResult.push({
        value: item,
        name: i18n.t(item),
      });
    }
    return arrayResult;
  }

  getValue (szKey, aFormatStr = []) {
    let lan = i18n.t(szKey);
    if (aFormatStr.length > 0) {
      aFormatStr.forEach((x) => {
        lan = lan.replace("%s", x);
      });
    }
    return lan;
  }

  // 将10进制RGB值转化成16进制
  transformRgb (str, hex) {
    let szRel;
    if (!str && str !== 0) {
      return str;
    }
    if (hex === 16) {
      szRel = parseInt(str.replace("#", ""), 16);
    } else {
      const aChar = ["0", "00", "000", "0000", "00000"];
      szRel = parseInt(str, 10).toString(16);
      if (szRel.length < 6) {
        // 不够6位 补0
        szRel = aChar[6 - szRel.length - 1] + szRel;
      }
      szRel = "#" + szRel;
    }
    if (typeof szRel === "string") {
      szRel = szRel.toUpperCase();
    }
    return szRel;
  }

  // #FFFFFF和透明度，转化成rgba
  getColor (color, transparent) {
    if (!color) {
      return 'unset';
      // return 'transparent';
      // return;
    }
    color = color.toLowerCase();
    const pattern = /^#([0-9|a-f]{3}|[0-9|a-f]{6})$/;
    if (color && pattern.test(color)) {
      if (color.length == 4) {
        // 将三位转换为六位
        color =
          "#" + color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
      }
      // 处理六位的颜色值
      const colorNew = [];
      for (let i = 1; i < 7; i += 2) {
        colorNew.push(parseInt("0x" + color.slice(i, i + 2)));
      }
      return "rgba(" + colorNew.join(",") + "," + transparent + ")";
    }
    return color;
  }

  // rgba或rgb转化成#FFFFFF和透明度
  rgbaToHexAndOpacity (r, g, b, a = 1) {
    // 将颜色通道值转换为十六进制
    let hexColor =
      "#" +
      ((1 << 24) + (parseInt(r) << 16) + (parseInt(g) << 8) + parseInt(b))
        .toString(16)
        .slice(1);
    // 提取透明度值
    let opacity = parseFloat(a);

    return { hexColor: hexColor, opacity: opacity };
  }

  // 获取一个随机时间串
  getUUIDTime () {
    const date = new Date();
    return (
      date.getFullYear().toString() +
      (date.getMonth() + 1).toString() +
      date.getDate().toString() +
      date.getHours().toString() +
      date.getMinutes().toString() +
      date.getSeconds()
    );
  }

  // 时间日期格式化
  dateFormat (oDate, fmt) {
    let o = {
      "M+": oDate.getMonth() + 1, //月份
      "d+": oDate.getDate(), //日
      "H+": oDate.getHours(), //小时
      "h+": oDate.getHours(), //小时
      "m+": oDate.getMinutes(), //分
      "s+": oDate.getSeconds(), //秒
      "q+": Math.floor((oDate.getMonth() + 3) / 3), //季度
      S: oDate.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (oDate.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
      }
    }
    return fmt;
  }

  // 判断当前窗口是否存在任一types类型中的窗口
  judgeExistTypes (window, types = []) {
    if (!Array.isArray(types)) {
      types = [types];
    }
    const sameType = types.includes(window.windowMode); // 和当前windowmode一致，说明肯定存在
    if (!window?.materialList) {
      return sameType;
    }
    const windowTypes = [
      ...new Set(window.materialList.map((material) => material.materialType)),
    ]; // 根据materiallist的所有类型来判断
    return sameType || types.some((type) => windowTypes.includes(type));
  }

  // 获取实时年月日，
  getCurTime (szType, bNextDay) {
    let szTimeStr;
    const oDate = new Date();
    const szYears = oDate.getFullYear();
    const szMonth = oDate.getMonth();
    let szDay = oDate.getDate();
    const szHour = oDate.getHours();
    const szMin = oDate.getMinutes();
    const szSecond = oDate.getSeconds();
    szDay = bNextDay ? szDay + 1 : szDay;

    if (szType === "hms") {
      szTimeStr = (szHour > 9 ? szHour : "0" + szHour).toString();
      szTimeStr += (szMin > 9 ? szMin : "0" + szMin).toString();
      szTimeStr += szSecond > 9 ? szSecond : "0" + szSecond;
    } else if (szType === "hms2") {
      szTimeStr = (szHour > 9 ? szHour : "0" + szHour).toString();
      szTimeStr += ":";
      szTimeStr += (szMin > 9 ? szMin : "0" + szMin).toString();
      szTimeStr += ":";
      szTimeStr += szSecond > 9 ? szSecond : "0" + szSecond;
    } else if (szType === "ymd") {
      szTimeStr = szYears; // 年
      szTimeStr += (szMonth > 8 ? szMonth + 1 : "0" + (szMonth + 1)).toString(); // 月
      szTimeStr += szDay > 9 ? szDay : "0" + szDay; // 日
    } else if (szType === "ymd2") {
      szTimeStr = szYears + "/"; // 年
      szTimeStr += (szMonth > 8 ? szMonth + 1 : "0" + (szMonth + 1)).toString(); // 月
      szTimeStr += "/";
      szTimeStr += szDay > 9 ? szDay : "0" + szDay; // 日
    } else if (szType === "date") {
      szTimeStr = szYears + "-"; // 年
      szTimeStr += (szMonth > 8 ? szMonth + 1 : "0" + (szMonth + 1)) + "-"; // 月
      szTimeStr += szDay > 9 ? szDay : "0" + szDay; // 日
      szTimeStr += "T";
      szTimeStr += (szHour > 9 ? szHour : "0" + szHour) + ":";
      szTimeStr += (szMin > 9 ? szMin : "0" + szMin) + ":";
      szTimeStr += szSecond > 9 ? szSecond : "0" + szSecond;
    } else if (szType === "noT") {
      szTimeStr = szYears + "-"; // 年
      szTimeStr += (szMonth > 8 ? szMonth + 1 : "0" + (szMonth + 1)) + "-"; // 月
      szTimeStr += szDay > 9 ? szDay : "0" + szDay; // 日
      szTimeStr += " ";
      szTimeStr += (szHour > 9 ? szHour : "0" + szHour) + ":";
      szTimeStr += (szMin > 9 ? szMin : "0" + szMin) + ":";
      szTimeStr += szSecond > 9 ? szSecond : "0" + szSecond;
    }

    return szTimeStr;
  }

  // 获取星期信息
  getWeekInfo () {
    const iDay = new Date().getDay();
    const aWeekMap = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    return aWeekMap[iDay];
  }

  // 移动数组中的位置,并修改z的值
  moveArrayItem (src, target, type, custom) {
    // 修改窗口层级，按下面的逻辑应该需要保证窗口是从层级从大到小排列
    if (custom === "window") {
      src = src.sort((a, b) => b.z - a.z);
    }
    try {
      src.forEach((item, index) => {
        if (type === "previous") {
          // 上移
          if (index === 0) {
            return;
          }
          if (item === target) {
            src[index] = src.splice(index - 1, 1, src[index])[0];
          }
        } else if (type === "next") {
          if (index === src.length - 1) {
            // 下移
            return;
          }
          if (item === target) {
            src[index] = src.splice(index + 1, 1, src[index])[0];
            throw new Error("next over");
          }
        } else if (type === "first") {
          // 置顶
          if (index === 0) {
            return;
          }
          if (item === target) {
            src.unshift(src[index]);
            src.splice(index + 1, 1);
          }
        } else if (type === "last") {
          // 置底
          if (index === src.length - 1) {
            return;
          }
          if (item === target) {
            src.push(src[index]);
            src.splice(index, 1);
          }
        }
      });
    } catch (e) {
      //
    }
    if (custom === "window") {
      // 窗口排序，重置z-index坐标
      src.forEach((item, index) => {
        item.z = src.length - index;
      });
    } else if (custom === "material") {
      src.forEach((item, index) => {
        item.index = index + 1;
      });
    }
  }

  // 计算字符串长度，一个双字节字符长度计2，ASCII字符计1
  lengthw (str) {
    return str.replace(/[^\x00-\xff]/g, "rr").length;
  }

  // 转换文件大小格式显示
  formatFileSize (fileSize) {
    if (!fileSize) {
      return "--";
    }
    const unitArr = ["B", "KB", "MB", "GB", "TB"];
    const index = Math.floor(Math.log(fileSize) / Math.log(1024));
    const size = fileSize / Math.pow(1024, index);

    return size.toFixed(2) + " " + unitArr[index];
  }

  // 生成节目缩略图，从节目编辑区域截取一张图
  generateShowThumbnail (seletor) {
    if (!Array.isArray(seletor)) {
      seletor = [seletor];
    }
    let oDrawingMyBoard;
    let index = 0;
    while (!oDrawingMyBoard && index < seletor.length) {
      oDrawingMyBoard = document.querySelector(seletor[index]);
      // oDrawingMyBoard = $(seletor[index]).get(0); // 节目编辑区域的dom对象
      index++;
    }

    // 截屏时去掉图片内的border，若后续其他地方需要调用该方法可做判断兼容
    oDrawingMyBoard.classList.add("isTransingCanvas");
    // $(oDrawingMyBoard).addClass("isTransingCanvas");
    return new Promise((resolve, reject) => {
      html2canvas(oDrawingMyBoard, {
        scale: 4,
        useCORS: true,
        // allowTaint: true,
      }).then(
        (canvas) => {
          try {
            // canvas宽度
            const canvasWidth = canvas.width;
            // canvas高度
            const canvasHeight = canvas.height;
            const retCanvas = document.createElement("canvas");
            retCanvas
              .getContext("2d")
              .drawImage(canvas, 0, 0, canvasWidth, canvasHeight); // 将图片绘制到canvas中
            const dataURL = canvas.toDataURL("image/jpeg");
            // 转换成二进制数据
            const imgFile = this.dataURLtoBlob(dataURL);
            if (!imgFile) {
              throw new Error(`error, base64: ${dataURL}`);
            }
            oDrawingMyBoard.classList.remove("isTransingCanvas");
            // $(oDrawingMyBoard).removeClass("isTransingCanvas");
            resolve(imgFile);
          } catch (e) {
            console.log(e);
            oDrawingMyBoard.classList.remove("isTransingCanvas");
            // $(oDrawingMyBoard).removeClass("isTransingCanvas");
            try {
              // 转换成二进制数据
              const imgFile = this.dataURLtoBlob(
                require("@/assets/image/program/failLoad_terminal.png")
              );
              resolve(imgFile);
            } catch (error) {
              reject();
            }
          }
        },
        () => {
          console.log("html2canvas错误");
          $(oDrawingMyBoard).removeClass("isTransingCanvas");
          try {
            // 转换成二进制数据
            const imgFile = this.dataURLtoBlob(
              require("@/assets/image/program/failLoad_terminal.png")
            );
            resolve(imgFile);
          } catch (error) {
            reject();
          }
        }
      );
    });
  }

  // base64转blob
  dataURLtoBlob (dataURL) {
    try {
      const arr = dataURL.split(",");
      const mime = arr[0].match(/:(.*?);/)[1]; // 图片格式
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    } catch (error) {
      return "";
    }
  }

  // 随机生成指定长度的字符串
  getRandomStr = (strLen) => {
    const len = strLen || 32;
    const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    const maxPos = chars.length;
    let pwd = "";
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  };

  // 获取文档文件实际类型
  getDocumentFileType (fileFormat) {
    if ([".doc", ".docx"].includes(fileFormat)) {
      return "doc";
    } else if ([".xls", ".xlsx"].includes(fileFormat)) {
      return "excel";
    } else if ([".ppt", ".pptx"].includes(fileFormat)) {
      return "ppt";
    } else if ([".pdf"].includes(fileFormat)) {
      return "pdf";
    } else {
      return "document";
    }
  }

  // 判断国际还是国内环境
  isIntl () {
    // if (process.env.NODE_ENV === "production") {
    //   return process.env.VUE_APP_BASE_API === "intl";
    // } else {
    //   // 本地联调环境判断 国内 还是国际 true 是国际  false 是国内
    //   return false;
    // }
    return mixin.computed.isIntl();
  }
}

const utils = new Utils();
export default utils;
